import { Component, Input } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TableChartComponent } from "src/app/components/dashboards/charts/table-chart/table-chart.component";
import { Severity } from "src/app/models/api/governance/violationRule.model";
import { ISelectedFilters } from "src/app/models/filters/selectedFilters.interface";
import { FiltersQueryTransformer } from "src/app/services/filters/filtersQueryTransformer.ts/filtersQueryTransformer";

@Component({
    selector: "app-resource-risk-table",
    templateUrl: "./resource-risk.component.html",
    styleUrls: ["./resource-risk.component.scss"],
})
export class ResourceRiskComponent<T> extends TableChartComponent<T> {
    @Input() public selectedFilters: ISelectedFilters;
    @Input() public linkable = false;

    // If not assigned, the table is not clickable. Temporary until we have all ids from the backend
    @Input() public filterCategory: string | null = null;

    constructor(
        private _router: Router,
        private _activatedRoute: ActivatedRoute,
    ) {
        super();
    }

    public onRowNameClicked(category: string) {
        if (!this.filterCategory || !this.linkable) return;
        this._navigateTo(`${this.filterCategory}:${category} violationStatus:open`);
    }

    public onSeverityClicked(severity: keyof typeof Severity, category: string) {
        if (!this.filterCategory || !this.linkable) return;
        this._navigateTo(`${this.filterCategory}:${category} severity:${severity} violationStatus:open`);
    }

    private _navigateTo(query: string) {
        let fullQuery = `${FiltersQueryTransformer.transformToQuery(this.selectedFilters)} ${query}`;

        if (fullQuery.includes("owaspLlm") === true) fullQuery = fullQuery + fullQuery.replace("owaspLlm", "owasp");

        this._router.navigate(["violations"], {
            relativeTo: this._activatedRoute,
            queryParams: { q: fullQuery },
            queryParamsHandling: "merge",
        });
    }
}
